export default __webpack_public_path__ + "static/media/problema-01.3282eff5.webp";